/** Canonical form for user emails; matches webbuilder-api `normalizeEmail`. */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}
